import { render, staticRenderFns } from "./RelacionarConDemanda.vue?vue&type=template&id=636bb8a2&scoped=true"
import script from "./RelacionarConDemanda.vue?vue&type=script&lang=ts"
export * from "./RelacionarConDemanda.vue?vue&type=script&lang=ts"
import style0 from "./RelacionarConDemanda.vue?vue&type=style&index=0&id=636bb8a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636bb8a2",
  null
  
)

export default component.exports